import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  loading: boolean = true;
  selectedIndex: number = 0;

  ngOnInit(): void {
    const savedIndex = localStorage.getItem('settings_tab_index');
    if (savedIndex) {
      this.selectedIndex = parseInt(savedIndex, 10);
    }

    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  onSelectedIndexChange(index: number): void {
    this.selectedIndex = index;
    localStorage.setItem('settings_tab_index', index.toString());
  }
}
